<template>
  <path
    d="M13.8548 4L7.05894 10.5659L5.08471 9.04368L3.89829 8.12664L2 10.4192L6.22363 13.6839L7.28667 14.5L16 6.0815L13.8548 4Z"
    fill="inherit"
  />
</template>
<script>
export default {
  name: 'icon-checkmark',
}
</script>
